import client from './client';

export interface AuditLogEntry {
  id: number;
  timestamp: string;
  actor_id: string | null;
  actor_role: string | null;
  actor_label: string | null;  // ISS-050
  action: string;
  target_type: string | null;
  target_id: string | null;
  target_label: string | null;  // ISS-050
  apartment_id: string | null;
  http_method: string | null;
  http_path: string | null;
  http_status: number | null;
  payload_summary: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
}

export interface AuditLogListResponse {
  items: AuditLogEntry[];
  total: number;
  page: number;
}

export interface AuditAction {
  value: string;
  name: string;
}

export interface AuditListParams {
  page?: number;
  limit?: number;
  date_from?: string;
  date_to?: string;
  action?: string;
  actor_id?: string;
  apartment_id?: string;
}

export const getList = async (params: AuditListParams = {}): Promise<AuditLogListResponse> => {
  const res = await client.get('/api/v1/audit', { params });
  return res.data;
};

export const getActions = async (): Promise<AuditAction[]> => {
  const res = await client.get('/api/v1/audit/actions');
  return res.data;
};

// ISS-039 — CSV export 안정화/보안 강화
export interface CsvExportResponse {
  job_id: string;
  message: string;
  row_count: number;
}

export const exportCsv = async (data: {
  date_from: string;
  date_to: string;
  action?: string;
}): Promise<CsvExportResponse> => {
  const res = await client.post('/api/v1/audit/export-csv', data);
  return res.data;
};

export const sendHeartbeat = async (batteryLevel?: number): Promise<unknown> => {
  const res = await client.post('/api/v1/audit/heartbeat', {
    battery_level: batteryLevel ?? null,
  });
  return res.data;
};
